const prepareNewItem = () => (
  {
    id: null,
    editable: true,
    enabled: true,
    question: null,
    abstract: true
  }
);

const addAttributeMethodsToScope = (scope) => {
  scope.getMetricIndex = (metric) => (scope.form.express_metrics.indexOf(metric));
  scope.getMetricNewItem = (metric, index) => {
    scope.state ||= {};
    const metricIndex = index || scope.getMetricIndex(scope, metric);
    if (!scope.state[metricIndex]) {
      scope.state[metricIndex] = prepareNewItem();
    }
    return scope.state[metricIndex];
  };

  scope.resetMetricNewItem = (metric, index) => {
    scope.state ||= {};
    const metricIndex = index || scope.getMetricIndex(metric);
    scope.state[metricIndex] = prepareNewItem();
  };

  scope.gridItemsWithAbstractNew = (metric) => (
    [ ...scope.actualGridItems(metric), ...[ scope.getMetricNewItem(metric) ] ]
  );

  scope.addItemIfAbstract = (metric, gridItem) => {
    if (!gridItem.abstract) {
      return;
    }
    const metricIndex = scope.getMetricIndex();
    const newItem = scope.getMetricNewItem(metric, metricIndex);
    newItem.position = parseInt(metric.grid_items[metric.grid_items.length - 1].position) + 1;
    newItem.abstract = false;
    metric.grid_items.push(newItem);
    scope.resetMetricNewItem(metric, metricIndex);
  };

  scope.attributeItemClassNames = (metric, gridItem) => (
    { '-abstract': gridItem.abstract, [`-dm-${metric.default_metric.name}`]: true }
  );

  scope.onAttributeKeydown = (metric, gridItem) => (event) => {
    if (event.keyCode !== 13) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (gridItem.abstract) {
      return;
    }
    const el = document.querySelector(`.-abstract.-dm-${metric.default_metric.name}`);
    el?.focus();
  };
};

export { addAttributeMethodsToScope };
